import 'slick-carousel/slick/slick.min';
import 'is-in-viewport/lib/isInViewport.min'
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import ScrollReveal from 'scrollreveal';

export default class Utils {
    constructor() {
        Utils.initializeViewport();
        Utils.click();
        Utils.tooltip();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.block_cover();
        Utils.backToTop();
        Utils.newsletterEmail();
        Utils.intializeRevealTitle();
    }

    static initializeViewport() {
        inView.threshold(0.5);

        inView('.strateAcessibilites').on('enter', function (elm) {

            if ($(elm).find('video').length) {
                $(elm).find('video').get(0).play();
            }
        });

        inView('.strateAcessibilites').on('exit', function (elm) {

            if ($(elm).find('video').length) {
                $(elm).find('video').get(0).pause();
            }
        });
    }

    static click() {

        const trigger = '[data-trigger="wpiris-click"]';

        if (!Modernizr.touchevents) {
            let ctrl = 0;
            $(window).on('keydown', function (e) {
                if (e.which == 17 || e.which == 91) {
                    ctrl = true
                }
            })
            $(window).on('keyup', function () {
                ctrl = false
            })

            $(document).on('mouseup', trigger, function (e) {

                if (e.target.tagName.toLowerCase() !== 'a') {
                    if (e.which == 1 || e.which == 2) {
                        let blank = false
                        let url = $(this).find("a").attr("href")
                        if (e.which == 2) {
                            blank = true
                        } // Clic molette
                        if ($(this).find("a").attr("target") == "_blank") {
                            blank = true
                        }
                        if (blank || ctrl) {
                            window.open(url, '_blank')
                        } else {
                            window.location = url
                        }
                        return false
                    }
                }
                return false

            })
        } else {
            $(document).on('click', trigger, function (e) {

                let blank = false
                let url = $(this).find("a").attr("href")
                if ($(this).find("a").attr("target") == "_blank") {
                    blank = true
                }
                if (blank) {
                    window.open(url, '_blank')
                } else {
                    window.location = url
                }
                return false

            })
        }
    }

    static tooltip() {
        if (!Modernizr.touchevents) {
            $('[data-toggle="tooltip"]').tooltip({trigger: "hover"})
        }
    }

    static fancybox() {

        $('.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")').attr('data-fancybox', 'fancybox')

        $('[data-fancybox="fancybox"]').fancybox({
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            lang: "fr",
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancyboxClose,
                    NEXT: Theme.translate.fancyboxNext,
                    PREV: Theme.translate.fancyboxPrev,
                    ERROR: Theme.translate.fancyboxError,
                    PLAY_START: Theme.translate.fancyboxStart,
                    PLAY_STOP: Theme.translate.fancyboxStop,
                    FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                    THUMBS: Theme.translate.fancyboxThumbs,
                    DOWNLOAD: Theme.translate.fancyboxDownload,
                    SHARE: Theme.translate.fancyboxShare,
                    ZOOM: Theme.translate.fancyboxZoom
                },
            },
            caption: function (instance, item) {
                let caption = $(this).closest('figure').find('figcaption').html()

                if (!caption) {
                    caption = $(this).find('img').attr('title')
                }

                if (!caption) {
                    caption = $(this).find('img').attr('alt')
                }

                return caption
            }
        })
    }

    static searchbox() {
        const trigger = '[data-trigger="wpiris-search-layout"]',
            close = '[data-trigger="wpiris-search-layout-close"]',
            $element = $('[data-id="wpiris-search-layout"]');

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        })

        $(document).on('click', close, function (e) {
            e.preventDefault();
            $element.fadeOut();
        })
    }

    static smooth_scroll() {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $(document).on('click', trigger, function (e) {
            e.preventDefault();

            const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href");
            const duration = 1000;

            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, duration);

        })
    }

    static lazy() {
        let lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg]'
        });
    }

    static block_cover() {
        $('.wp-block-cover:has(.wp-block-cover__inner-container a)').attr('data-trigger', 'wpiris-click')
    }

    static backToTop() {
        $('.backtotop').on('click', function (e) {
            e.preventDefault()

            if ($(window).scrollTop() != 0) {
                $('html, body').animate({scrollTop: 0}, 300)
            }
        })

        $(window).on('scroll', function (e) {

            if ($(this).scrollTop() > 250) {
                $('.backtotop').addClass('backtotop--show')
            } else {
                $('.backtotop').removeClass('backtotop--show')
            }
        })
    }

    static newsletterEmail() {
        if ($('.page-id-67').length > 0) {
            let email = $POST_EMAIL;
            $('input[name="email"]').attr('value', email);
            $('input[name="email"]').parent().parent().addClass('is-focused');
        }
    }

    static intializeRevealTitle() {
        if (!Modernizr.touchevents) {

            ScrollReveal().reveal('.strateAcessibilites', {
                delay: 1,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '10%',
                origin: 'bottom',
                opacity: 0,
            });

            ScrollReveal().reveal('.strateMobilitesInner', {
                delay: 500,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '10%',
                origin: 'bottom',
                opacity: 0,
            });

            ScrollReveal().reveal('.strateMobilitesInnerBloc', {
                delay: 500,
                interval: 400,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '40%',
                origin: 'bottom',
                opacity: 0,
            });


            ScrollReveal().reveal('.stratePost', {
                delay: 500,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '10%',
                origin: 'bottom',
                opacity: 0,
            });

            ScrollReveal().reveal('.strateCollectivitesOther', {
                delay: 500,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '10%',
                origin: 'bottom',
                opacity: 0,
            });

            ScrollReveal().reveal('.strateMaasifyInner', {
                delay: 500,
                duration: 1000,
                reset: false,
                easing: 'ease',
                distance: '10%',
                origin: 'bottom',
                opacity: 0,
            });

            ScrollReveal().reveal('.strateCollectivitesInnerImgTicketOne', {
                delay: 500,
                distance: '100%',
                origin: 'left',
                duration: 1500,
                opacity: 0,
                easing: 'ease',
            });

            ScrollReveal().reveal('.strateCollectivitesInnerImgTicketTwo', {
                delay: 500,
                distance: '100%',
                origin: 'right',
                duration: 1500,
                opacity: 0,
                easing: 'ease',
            });
        }
    }
}

